import api from '@/api'
import intentApi from '@/api/intent.js'
import { handleApiError, handleResponse } from '@/api/util'
import question from '@/assets/js/atomicData.js'
import FilterCustomer from '@/components/elements/FilterCustomer'
import config from '@/config'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import AtomicboyCustomerItem from './AtomicboyCustomerItem'

export default {
  data: function () {
    var headers = []
    // console.log(this.$store.state.selectedBot)

    if (this.$store.state.selectedBot.theme == 'hafele') {
      headers.push({ text: this.$t('ID'), value: 'emp_id' })
    }

    // headers = headers.concat([
    //   { text: '', sortable: false },
    //   { text: this.$t('name'), value: 'first_name' },
    //   { text: this.$t('Channel'), value: 'app' },
    //   { text: this.$t('gender'), value: 'gender' },
    //   { text: this.$t('Register Date'), value: 'registertimestamp' },
    //   { text: this.$t('Last Active Date'), value: 'timestamp' },
    //   { text: this.$t('Email'), value: 'email' },
    //   { text: this.$t('phone no.'), value: 'phoneno' },
    //   { text: this.$t('Status'), value: 'status' },
    //   { text: this.$t('Locale'), value: 'locale' },
    //   { text: this.$t('Lineid'), value: 'lineid' },
    //   { text: this.$t('Province'), value: 'province' },
    //   { text: this.$t('School'), value: 'school' },
    //   { text: '', sortable: false }
    // ])
    headers = headers.concat([
      { text: '', sortable: false },
      { text: this.$t('name'), value: 'first_name' },
      { text: this.$t('Channel'), value: 'app' },
      { text: this.$t('gender'), value: 'gender' },
      { text: this.$t('Age'), value: 'age' },
      { text: 'PDPA Agreement', value: 'pdpa' },
      // { text: this.$t('Attention'), value: 'attention' },
      // { text: this.$t('Total score'), value: 'totalscore' },
      // { text: this.$t('บทที่ 1'), value: 'ep1' },
      // { text: this.$t('บทที่ 2'), value: 'ep2' },
      // { text: this.$t('บทที่ 3'), value: 'ep3' },
      // { text: this.$t('บทที่ 4'), value: 'ep4' },
      { text: '', sortable: false }
    ])

    return {
      headers: headers,
      pageNumber: 1,
      pagination: { rowsPerPage: -1, sortBy: '' },
      tag: '',
      singleStatus: '',
      showAdvance: false,
      users: [],
      limit: 100,
      offset: 0,
      hasNext: true,
      count: 0,
      gendercount: '',
      users_count: [],
      intents: [],
      delayImport: false,
      search: '',
      filter: {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: '',
        lineid: '',
        school: '',
        province: '',
        uu_register_status: '',
        specialcondition: '',
        statustype: 'includes'
      },
      loading: true,
      errorFilterTag: [],
      pagetmp: 1,
      errorFilterStatus: [],
      customerfromfb: null,
      total_user: '',
      exportlimit: 5000,
      showExport: false,
      exportpagecount: 0,
      exportType: null
    }
  },
  components: {
    ScaleLoader,
    AtomicboyCustomerItem,
    PulseLoader,
    Multiselect,
    FilterCustomer
  },
  mounted: async function () {
    var vm = this
    vm.loading = true
    vm.getIntent().then(() => {
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function (users) {
          vm.offset += vm.limit

          for (let i = 0; i < users.length; i++) {
            let score = {
              chap1: 0,
              chap2: 0,
              chap3: 0,
              chap4: 0,
              sumScore: 0,
              fullScore: 0
            }
            if (users[i].session) {
              let session = JSON.parse(users[i].session)
              // console.log('session', session)
              if (users[i].session) {
                for (const property in session) {
                  // console.log('property', property)
                  if (property.match('chat1')) {
                    if (property.match('score')) {
                      // console.log('match chat1 :', property)
                      score.chap1 += parseInt(session[property])
                      score.sumScore += parseInt(session[property])
                      score.fullScore++
                    }
                  }
                  if (property.match('chap2')) {
                    if (property.match('score')) {
                      // console.log('match chat2 :', property, session[property])
                      score.chap2 += parseInt(session[property])
                      score.sumScore += parseInt(session[property])
                      score.fullScore++
                    }
                  }
                  if (property.match('chap3')) {
                    if (property.match('score')) {
                      // console.log('match chat3 :', property)
                      score.chap3 += parseInt(session[property])
                      score.sumScore += parseInt(session[property])
                      score.fullScore++
                    }
                  }
                  if (property.match('chap4')) {
                    if (property.match('score')) {
                      // console.log('match chat4 :', property)
                      score.chap4 += parseInt(session[property])
                      score.sumScore += parseInt(session[property])
                      score.fullScore++
                    }
                  }
                }
              }
            }
            users[i] = { ...users[i], score: { ...score } }
          }
          // console.log('users :', users)
          vm.users = users
          vm.loading = false
        },
        function () {
          vm.loading = false
        }
      )
    })
    vm.$store.dispatch('loadStatus')
  },
  computed: {
    usersFilter() {
      let output = []
      this.users.forEach((user) => {
        let temp_data = user
        temp_data.json_variable = user.json_variable ? JSON.parse(user.json_variable) : {}
        // const regex = /chap/gim
        // let data = user.session.replace(regex, 'Chapter ')
        // temp_data.session = user.session ? JSON.parse(data) : null
        output.push(temp_data)
      })
      return output
    },
    intentQuestions() {
      let output = []
      if (this.intents.length) {
        // let chapter_regex = new RegExp(key.replace(/\'/gim, '') + 'chapter [0-9]-[0-9]+', 'gim')
        this.intents.forEach((intent) => {
          let res = intent.intentname.match(/Chapter\s[0-9]+-[0-9]+_Q\d+/gim)
          if (res) {
            output.push(intent)
          }
          // if (intent.intentname.match(chapter_regex)) {

          // }
        })
      }
      return output
    },
    question() {
      return question
    },
    pagelength() {
      if (this.total_user) {
        return Math.ceil(this.total_user / 100)
      } else {
        return 1
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filteredHeader() {
      Array.prototype.insert = function (index) {
        index = Math.min(index, this.length)
        arguments.length > 1 &&
          this.splice.apply(this, [index, 0].concat([].pop.call(arguments))) &&
          this.insert.apply(this, arguments)
        return this
      }

      if (this.isBU) return this.headers
      else if (this.$store.state.niveapage.includes(this.selectedBot.pageid)) {
        return [
          { text: '', sortable: false },
          { text: this.$t('name'), value: 'first_name' },
          { text: this.$t('Channel'), value: 'app' },
          { text: this.$t('gender'), value: 'gender' },
          { text: this.$t('Message Sent'), value: 'usermessages' },
          { text: this.$t('Register Date'), value: 'registertimestamp' },
          { text: this.$t('Last Active Date'), value: 'timestamp' },
          { text: this.$t('Email'), value: 'email' },
          { text: this.$t('phone no.'), value: 'phoneno' },
          { text: this.$t('Status'), value: 'status' },
          { text: this.$t('Locale'), value: 'locale' },
          { text: '', sortable: false }
        ]
      } else if (this.selectedBot.theme == 'scgdistribution') {
        return this.headers
          .filter((v) => {
            return !['lineid', 'province', 'school'].includes(v.value)
          })
          .insert(2, [
            {
              text: this.$t('Shop code'),
              value: 'cardnumber',
              align: 'left',
              width: 'auto'
            },
            {
              text: this.$t('Shop name'),
              value: 'realname',
              align: 'left',
              width: 'auto'
            },
            {
              text: this.$t('Province'),
              value: 'province',
              align: 'left',
              width: 'auto'
            }
          ])
      } else {
        return this.headers.filter((v) => {
          return !['lineid', 'province', 'school'].includes(v.value)
        })
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      computedImportDelay: 'getDelayCustomerImport'
    }),
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function (s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    }
  },
  methods: {
    onCountdownEnd() {
      this.$store.commit('REMOVE_DELAY_IMPORT', {
        pageid: this.selectedBot.pageid
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * 100 - 100
        vm.pageloading = true
        this.getMoreCustomers()
      }
    },
    estimateReach: function (data) {
      var vm = this

      vm.loadingEstimate = true
      api.estimateReach(data, function (error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.data) {
          vm.total_user = response.data.total
        }
      })
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function (newTags) {
      this.status = newTags
    },
    clearSearch: function () {
      this.filter = {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        status: ''
      }
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: function () {
      var vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        vm.offset = 0
        vm.hasNext = true
        vm.users = []
        vm.loading = true
        vm.getLoadUsers(vm.limit, vm.offset).then(
          function (users) {
            vm.users = vm.users.concat(users)
            vm.loading = false
          },
          function (error) {
            vm.loading = false
          }
        )
      })
    },
    collectexportcustomersanalytic() {
      var vm = this
      let data = {
        pageid: vm.pageid,
        grouptype: vm.grouptype,
        filter: vm.filter,
        limit: vm.limit,
        offset: vm.offset
      }

      api.putcollectexportcustomersanalytic(data, function (error, response) {
        if (error) {
          console.error(error)

          return
        }
      })
    },
    getLoadUsers: function (limit, offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.pageid,
          grouptype: vm.grouptype,
          filter: vm.filter,
          limit: limit,
          offset: offset
        }

        api.getAllUsers(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (vm.limit > response.data.length) {
            vm.hasNext = false
          }

          var users = response.data
          vm.total_user = response.count
          resolve(users)
        })
      })
    },
    getMoreCustomers: function () {
      var vm = this
      vm.loading = true
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function (users) {
          vm.offset += vm.limit
          vm.users = users
          vm.loading = false
        },
        function (error) {
          vm.loading = false
        }
      )
    },
    onFailLoad: function (index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    onActiveStartDate: function (value) {
      var vm = this
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function (value) {
      var vm = this
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    getIntent: async function () {
      const vm = this
      const params = {
        pageid: vm.pageid,
        search_intent: 'Chapter',
        offset: 0,
        limit: 10000,
        page_intent: 'conversation',
        sort_by: 'intentname',
        sort_type_available: 'asc'
      }
      try {
        const response = await intentApi.getIntent({ params })
        await handleResponse(response)
        const data = response.data.data
        if (data) {
          vm.intents = data.map((intent) => ({ ...intent, isShow: false }))
        }
      } catch (error) {
        handleApiError(error)
      }
    },

    async exportDataSummary(offset) {
      let vm = this
      var limit = 5000
      vm.loading = true

      var users = await vm.getLoadUsers(limit, offset)
      if (users && users.length > 0) {
      }
      var json = []
      if (typeof users !== 'undefined') {
        users.map((item) => {
          var userid =
            vm.$store.getters.getPackage == 'premium'
              ? item.id
                ? item.id
                : '-'
              : this.$t('premium')
          var userid_split = null
          try {
            userid_split = item.app == 'line' ? userid.split('__')[0] : userid
          } catch (error) {
            userid_split = userid
          }
          var userData = {
            pageuid: userid_split,
            'Social Name':
              (item.first_name ? item.first_name : '') +
              ' ' +
              (item.last_name ? item.last_name : ''),
            'E-mail': item.email,
            Phone: item.phoneno
          }
          if (item.session) {
            Object.assign(userData, JSON.parse(item.session))
          }
          json.push(userData)
        })
        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'zwiz-data-summary.csv')
        vm.loading = false
      }
      vm.collectexportcustomersanalytic()
    },

    exportCustomer: function (offset = 0) {
      let vm = this
      let csvContent = ''

      var limit = 5000
      vm.loading = true

      vm.getLoadUsers(limit, offset).then(
        function (users) {
          if (users && users.length > 0) {
            var json = []
            $.each(users, function (index, val) {
              let locale = config.locale.find(function (locale) {
                if (val.locale == locale.value) {
                  return true
                }
              })
              var userid =
                vm.$store.getters.getPackage == 'premium'
                  ? val.id
                    ? val.id
                    : '-'
                  : this.$t('premium')
              var userid_split = null
              try {
                userid_split = val.app == 'line' ? userid.split('__')[0] : userid
              } catch (error) {
                userid_split = userid
              }
              var userData = {
                pageuid: userid_split,
                'Social Name':
                  (val.first_name ? val.first_name : '') +
                  ' ' +
                  (val.last_name ? val.last_name : ''),
                Channel: val.app,
                Gender: val.gender,
                'Register Date': val.registertimestamp
                  ? moment(val.registertimestamp).format('DD/MM/YYYY')
                  : '-',
                'Last Active Date': val.timestamp
                  ? moment(val.timestamp).format('DD/MM/YYYY')
                  : '-',
                Email:
                  vm.$store.getters.getPackage == 'premium'
                    ? val.email
                      ? val.email
                      : ''
                    : this.$t('premium'),
                Address: val.address,
                'Phone No':
                  vm.$store.getters.getPackage == 'premium' ? val.phoneno : this.$t('premium'),
                Status: vm.$store.getters.getPackage == 'premium' ? val.status : this.$t('premium'),
                Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : this.$t('premium'),
                // 'Message Sent':
                //   vm.$store.getters.getPackage == 'premium' ? val.messagesent : this.$t('premium'),
                Locale: locale ? locale : ''
                // Intent:
                //     vm.$store.getters.getPackage == 'premium'
                //         ? val.intentlist
                //             ? val.intentlist.join(',')
                //             : ''
                //         : this.$t('premium'),
                // MessageSent: val.questionmessages ? val.questionmessages.replace(/;;/gim, ',') : '',
                // NumberMessageSent: val.usermessages
              }

              json.push(userData)
            })

            // vm.exportCsv(csvContent, 'zwiz-customer-' + offset)
            const dataWS = XLSX.utils.json_to_sheet(json)
            const csv = XLSX.utils.sheet_to_csv(dataWS)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwiz-customer.csv')
            vm.loading = false
          } else {
            vm.loading = false
          }
        },
        function () {
          vm.loading = false
        }
      )
      vm.collectexportcustomersanalytic()
    },
    onExportCustomer(type) {
      this.exportType = type
      this.exportpagecount = Math.ceil(this.total_user / this.exportlimit)
      if (this.exportpagecount > 1) {
        this.showExport = true
      } else {
        if (this.exportType === 'dataSummary') {
          this.exportDataSummary(0)
        } else if (this.exportType === 'info' || true) {
          this.exportCustomer(0)
        }
      }
    },
    importCustomer: function () {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to import customer?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: vm.selectedBot.pageid
            }
            vm.loading = true
            vm.offset = 0
            vm.hasNext = true
            vm.users = []
            api.insertUsersFromInbox(data, async function (error, response) {
              if (error) {
                vm.loading = false
                return
              }
              if (response.responsecode == 200) {
                api.insertUsersFromDone(data, function (error, response) {
                  vm.getLoadUsers(vm.limit, vm.offset).then(
                    function (users) {
                      vm.users = vm.users.concat(users)
                      vm.delayImport = true
                      var time = moment().add(1, 'hours').format('YYYY-MM-DD HH:mm:ss')
                      vm.$store.commit('SET_DELAY_IMPORT', {
                        pageid: vm.selectedBot.pageid,
                        time: time
                      })
                      vm.$swal.fire({
                        title: vm.$t('Import customer successful'),
                        type: 'success',
                        confirmButtonText: vm.$t('Confirm'),
                        cancelButtonText: vm.$t('cancel'),
                        reverseButtons: true
                      })
                      vm.loading = false
                    },
                    function (error) {
                      vm.loading = false
                    }
                  )
                })
              }
            })
          }
        })
    }
  },
  watch: {
    count: function (newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$emit('onUserLoaded', vm.count)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/dashboard/customize/atomicboy/AtomicboyCustomers.js